module.exports = __webpack_public_path__ + "media/applicants/icon-close-thin-dd6da2ef.png";